import React from 'react';
import { DropFileError } from "../../drop-common";
import formatSize from 'pretty-bytes';
import { Slug } from '@isyc-react/animation/modules/base/trail';
import { useTranslation } from 'react-i18next';
import { nsformfile } from "../../../../../i18n/namespaces";
import { RippleButton } from '@isyc-react/form/modules/base/button';
import '@isyc-react/design/main';
const RejectedFileError = props => {
  var _file$name$split$pop;
  const {
    file,
    error
  } = props;
  const {
    i18n,
    t
  } = useTranslation(nsformfile.common);
  switch (error.code) {
    case DropFileError.TOO_MANY_FILES:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, t('drop.rejected.reason.tooManyFiles'));
    case DropFileError.INVALID_TYPE:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, t('drop.rejected.reason.invalidType', {
        ext: (_file$name$split$pop = file.name.split('.').pop()) === null || _file$name$split$pop === void 0 ? void 0 : _file$name$split$pop.toLowerCase()
      }));
    case DropFileError.TOO_LARGE:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, t('drop.rejected.reason.tooLarge', {
        size: formatSize(props.file.size, {
          locale: i18n.language
        })
      }));
    case DropFileError.TOO_SMALL:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, t('drop.rejected.reason.tooSmall', {
        size: formatSize(props.file.size, {
          locale: i18n.language
        })
      }));
    default:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, t('drop.rejected.reason.default'));
  }
};
export const DropSingleRejectedView = props => {
  const {
    rejected,
    open,
    remove,
    disabled
  } = props;
  const {
    t
  } = useTranslation(nsformfile.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-between flex-wrap"
  }, /*#__PURE__*/React.createElement(Slug, {
    delay: 100,
    config: {
      tension: 100,
      friction: 10
    },
    from: {
      opacity: 0,
      transform: 'translate3d(0px,50px,0)'
    }
  }, /*#__PURE__*/React.createElement("div", null, rejected.map((rejection, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-start"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-red fw-bold"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-close text-red"
  }), " ", rejection.file.name))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column justify-content-start"
  }, /*#__PURE__*/React.createElement(Slug, {
    delay: 100,
    config: {
      tension: 100,
      friction: 10
    },
    from: {
      opacity: 0,
      transform: 'translate3d(0px,50px,0)'
    }
  }, rejection.errors.map((error, j) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: j
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RejectedFileError, {
    file: rejection.file,
    error: error
  }))))))))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-outline-primary me-2",
    onClick: open,
    disabled: disabled
  }, t('drop.zone.rejected.change')), /*#__PURE__*/React.createElement(RippleButton, {
    type: "button",
    className: "btn btn-outline-primary",
    onClick: remove,
    disabled: disabled
  }, t('drop.zone.rejected.remove'))))));
};